import type {RemoteSelectionOutline} from './page-presence-layer.types';

/**
 * Measured from the live Fabric objects of the editor on the page. `itemTransformVersion` is
 * taken only so the caller's memoised result follows every move, scale and rotate tick.
 */
export const getRemoteSelectionOutlines = (itemIds: string[], _itemTransformVersion: number): RemoteSelectionOutline[] => {
  const outlines: RemoteSelectionOutline[] = [];
  for (const itemId of itemIds) {
    const item = window.posterEditor?.whiteboard?.getItemForId(itemId);
    if (item === undefined) {
      continue;
    }
    const {left, top, width, height} = item.fabricObject.getBoundingRect();
    outlines.push({itemId, left, top, width, height});
  }
  return outlines;
};
